(function () {
  'use strict';
  if (window.swapwearPanelSet) return;
  const MAX = 5;
  const STORAGE = 'swapwear:panel-set:goal:v1';
  const observedCarts = new Map();
  const staleGrowthCarts = new Set();
  let latestCart = window.__initialData?.cart || { items: [] };
  let selectedGoal = 0;
  try { selectedGoal = Number(window.localStorage?.getItem(STORAGE)) || 0; } catch (_) {}
  try {
    const path = String(window.location?.pathname || '');
    const requested = Number(new URLSearchParams(window.location?.search || '').get('set_panels'));
    if (/\/(?:products\/[^/]+|collections\/build-bundle)\/?$/.test(path) && Number.isSafeInteger(requested) && requested > 0) selectedGoal = requested;
  } catch (_) {}
  if (!Number.isSafeInteger(selectedGoal) || selectedGoal < 1) {
    selectedGoal = 3;
  }
  selectedGoal = Math.min(MAX, selectedGoal);
  const properties = item => Array.isArray(item?.properties) ? Object.fromEntries(item.properties) : (item?.properties || {});
  const idOf = item => String(item?.variant_id || item?.variantId || item?.id || '');
  const units = item => Math.max(0, Math.trunc(Number(item?.quantity) || 0));
  const copy = (key, fallback) => window.__initialData?.panelSetCopy?.[key] || fallback;
  const emit = (type, detail) => window.dispatchEvent(new CustomEvent(type, { detail }));
  function isPaidPanel(item) {
    const type = String(item?.product_type || item?.productType || item?.type || '').toLowerCase();
    if (!['swappable patch', 'swappable panel', 'art panel'].some(value => type.includes(value))) return false;
    const name = `${item?.product_title || item?.title || ''} ${item?.handle || ''}`;
    const props = properties(item);
    const mystery = window.__initialData?.mystery_data || [];
    if (/mystery|blank panel|blank-panel|matching blank/i.test(name)) return false;
    if (props._free_gift || props._gift || props._mystery_reward || props._included_blank) return false;
    if (Object.values(mystery).some(gift => {
      const configured = gift?.rewardVariantId || gift?.variant_id || gift?.variantId || '';
      const id = String(configured?.id || configured?.value || configured).replace('gid://shopify/ProductVariant/', '');
      return Boolean(id && id === idOf(item));
    })) return false;
    return true;
  }
  function count(cart = latestCart) { return (cart?.items || []).reduce((sum, item) => sum + (isPaidPanel(item) ? units(item) : 0), 0); }
  function persist() { try { window.localStorage?.setItem(STORAGE, String(selectedGoal)); } catch (_) {} }
  function cartSignature(cart) {
    return JSON.stringify((cart?.items || []).filter(isPaidPanel).map(item => [String(item.key || idOf(item)), units(item)]).sort((a, b) => a[0].localeCompare(b[0])));
  }
  function protectGoalFromOldCarts(goal) {
    observedCarts.forEach((quantity, signature) => { if (quantity > goal) staleGrowthCarts.add(signature); });
    while (staleGrowthCarts.size > 32) staleGrowthCarts.delete(staleGrowthCarts.values().next().value);
  }
  function snapshot(cart = latestCart) {
    const quantity = count(cart);
    return { goal: selectedGoal, count: quantity, remaining: Math.max(0, selectedGoal - quantity), complete: selectedGoal > 0 && quantity >= selectedGoal, overLimit: false, max: MAX, selected: selectedGoal > 0 };
  }
  function changed(cart = latestCart, reason = 'goal') { emit('swapwear:panel-set-updated', { ...snapshot(cart), cart, reason }); }
  function observe(cart, notify = true) {
    if (!cart || !Array.isArray(cart.items)) return;
    latestCart = cart;
    const quantity = count(cart);
    const signature = cartSignature(cart);
    observedCarts.set(signature, quantity);
    while (observedCarts.size > 32) observedCarts.delete(observedCarts.keys().next().value);
    // Shortlisting stays open: confirmed additions grow the goal up to five,
    // while a removal never lowers it. Ignore pre-downsize snapshots until a
    // subsequent confirmed mutation establishes new shopper intent.
    const nextGoal = Math.min(MAX, quantity);
    if (nextGoal > selectedGoal && !staleGrowthCarts.has(signature)) {
      selectedGoal = nextGoal;
      persist();
    }
    if (notify) changed(cart, 'cart');
  }
  function slots(cart = latestCart) {
    const result = [];
    (cart?.items || []).filter(isPaidPanel).forEach(item => {
      for (let index = 0; index < units(item); index++) result.push({ ...item, id: item.variant_id || item.id, title: item.product_title || item.title || '', image: item.image || item.featured_image?.url || item.featured_image || '', unitIndex: index, slotKey: `${item.key || idOf(item)}:${index}` });
    });
    while (result.length < selectedGoal) result.push(null);
    return result;
  }
  function action(kind, extra = {}, cart = latestCart) { emit('swapwear:panel-set-action', { kind, ...snapshot(cart), items: slots(cart).filter(Boolean), ...extra }); }
  function selectGoal(value, cart = latestCart) {
    const next = Number(value);
    if (!Number.isSafeInteger(next) || next < 1 || next > MAX) return false;
    if (count(cart) > next) { action('reduce', { target: next }, cart); return false; }
    selectedGoal = next;
    protectGoalFromOldCarts(next);
    persist();
    changed(cart, 'selected');
    return true;
  }
  const ACTIVATION_STORAGE = 'swapwear:panel-set:activation:v1';
  let promotionTapRevision = 0;
  function activationToast(goal) {
    const host = root();
    if (typeof host?.showToast !== 'function') return false;
    try { host.showToast({
      type: 'panel-set-activation',
      message: copy('activation_toast', 'Your __COUNT__-Swap bundle is activated.').replace('__COUNT__', goal),
      icon: 'check', className: 'custom-toast-sms--dark', timeout: 2200,
      isCurrent: () => selectedGoal === goal
    }); return true; } catch (_) { return false; }
  }
  function consumeActivation() {
    let pending;
    try { pending = JSON.parse(window.sessionStorage?.getItem(ACTIVATION_STORAGE) || 'null'); } catch (_) { return false; }
    if (!pending) return false;
    const age = Date.now() - Number(pending.at);
    if (pending.goal !== selectedGoal || !(age >= 0 && age < 30000)) {
      try { window.sessionStorage?.removeItem(ACTIVATION_STORAGE); } catch (_) {}
      return false;
    }
    if (!activationToast(pending.goal)) return false;
    try { window.sessionStorage?.removeItem(ACTIVATION_STORAGE); } catch (_) {}
    return true;
  }
  function activateGoal(value, cart = latestCart, options = {}) {
    if (!selectGoal(value, cart)) return false;
    try { window.swapwearPromo?.activateAutomatic?.({ silent: true }); } catch (_) {}
    try { window.sessionStorage?.removeItem(ACTIVATION_STORAGE); } catch (_) {}
    if (options.deferToast === true) {
      try {
        if (typeof window.sessionStorage?.setItem === 'function') {
          window.sessionStorage.setItem(ACTIVATION_STORAGE, JSON.stringify({ goal:selectedGoal, at:Date.now() }));
          return true;
        }
      } catch (_) {}
    }
    activationToast(selectedGoal);
    return true;
  }
  function activatePromotion(cart = latestCart, options = {}) {
    const profile = root()?.sale_profile || window.__initialData?.sale_profile || {};
    const current = promotionProgress(cart, profile);
    if (!saleActive(profile) && !current.firstSwap.enabled) return false;
    try { window.swapwearPromo?.activateAutomatic?.({ silent: true }); } catch (_) {}
    const host = root();
    const threshold = Number(options.threshold);
    const targeted = Number.isInteger(threshold) && threshold >= 1 && threshold <= MAX;
    const hostPending = host?.cart_loading === true || host?.cart_needs_refresh === true;
    const pending = options.pending === true || hostPending;
    const tapRevision = targeted ? ++promotionTapRevision : promotionTapRevision;
    const remaining = targeted ? Math.max(0, threshold - current.count) : 0;
    const manualApplied = profile.type === 'sitewide' && profile.offer?.application_method === 'code' &&
      window.swapwearPromo?.confirmation?.(cart, profile.offer.code)?.applied === true;
    let message;
    if (targeted && pending) message = copy('dialog_busy', 'Updating your cart…');
    else if (targeted && remaining > 0) message = milestoneText(remaining === 1 ? 'tier_remaining_one' : 'tier_remaining_many',
      remaining === 1 ? 'Add __COUNT__ more Swap to reach this tier.' : 'Add __COUNT__ more Swaps to reach this tier.',
      { count: remaining });
    else if (manualApplied) message = copy('applied', 'Applied');
    else if (targeted) message = progressMessage({ ...current, next: null }) ||
      milestoneText('tier_reached', '__COUNT__-Swap tier reached.', { count: threshold });
    else message = progressMessage(current) || copy('promo_active_toast', 'Promo active');
    const signature = progressSignature(cart, profile);
    try { host?.showToast?.({
      type: 'coupon', message,
      icon: (!targeted || !pending && remaining === 0) && (manualApplied || current.savings.applied || current.firstSwap.applied) ? 'celebrate' : 'check',
      className: 'custom-toast-sms--dark custom-toast-sms--coupon', timeout: 3500,
      isCurrent: () => {
        const currentProfile = root()?.sale_profile || window.__initialData?.sale_profile || {};
        const currentCart = root()?.cart || latestCart;
        const currentHost = root();
        const stillPending = currentHost?.cart_loading === true || currentHost?.cart_needs_refresh === true;
        return (!targeted || tapRevision === promotionTapRevision && hostPending === stillPending) && progressSignature(currentCart, currentProfile) === signature &&
          (saleActive(currentProfile) || firstSwapState(currentCart).enabled);
      }
    }); } catch (_) {}
    return true;
  }
  function saleActive(profile = {}) {
    const now = Date.now();
    return profile.active === true && (!profile.start || now >= Date.parse(profile.start)) && (!profile.end || now < Date.parse(profile.end));
  }
  function isBase(item) {
    return (window.__initialData?.bases || []).some(base => base.handle && base.handle === item?.handle);
  }
  function isGift(item) {
    const props = properties(item);
    const name = `${item?.product_title || item?.title || ''} ${item?.handle || ''}`;
    return /mystery|blank panel|blank-panel|matching blank/i.test(name) || props._gift || props._free_gift || props._mystery_reward || props._included_blank ||
      Object.values(window.__initialData?.mystery_data || {}).some(gift => {
        const configured = gift?.rewardVariantId || gift?.variant_id || gift?.variantId || '';
        const id = String(configured?.id || configured?.value || configured).replace('gid://shopify/ProductVariant/', '');
        return Boolean(id && id === idOf(item));
      });
  }
  function savingsApplied(cart = latestCart, percentage = 0, profile = window.__initialData?.sale_profile || {}) {
    const rate = Number(percentage);
    if (!(rate > 0 && rate <= 100)) return false;
    const mode = profile.tierMode || profile.offer?.tier_mode || '';
    const scope = profile.type === 'sitewide' && (!profile.offer?.target || profile.offer.target === 'all') ? 'all' :
      profile.type === 'tier' && mode === 'panel_and_base' ? 'both' : 'panels';
    const freeSwapUsesBase = scope === 'both' && firstSwapState(cart).applied;
    const lines = (cart?.items || []).filter(item => units(item) > 0 && !isGift(item) &&
      (scope === 'all' || isPaidPanel(item) || scope === 'both' && !freeSwapUsesBase && isBase(item)));
    const freeCode = String(window.__initialData?.firstSwapOffer?.code || '').trim().toUpperCase();
    const hasSelectedCode = (cart?.discount_codes || []).some(entry => String(entry?.code || '').trim());
    const isCode = application => application?.type === 'discount_code' || Boolean(application?.code) ||
      Boolean(freeCode && String(application?.title || '').trim().toUpperCase() === freeCode);
    let original = 0, saved = 0, tolerance = 0;
    for (const item of lines) {
      const before = Math.max(0, Number(item.original_line_price ?? Number(item.original_price ?? item.price ?? 0) * units(item)) || 0);
      const after = Number(item.final_line_price ?? item.line_price ?? Number(item.final_price ?? item.price ?? 0) * units(item));
      const allocations = item.discount_allocations?.length ? item.discount_allocations : item.line_level_discount_allocations || [];
      const rounding = Math.max(1, units(item));
      if (allocations.length) {
        const codeAmount = allocations.reduce((sum, allocation) => {
          const application = allocation?.discount_application || {};
          return sum + (isCode(application) ? Math.max(0, Number(allocation.amount) || 0) : 0);
        }, 0);
        const eligible = Math.max(0, before - codeAmount);
        const allocated = allocations.reduce((sum, allocation) => {
          const application = allocation?.discount_application || {};
          if (isCode(application)) return sum;
          const percentage = application.value_type === 'percentage' ? Number(application.value) :
            Number(String(application.title || '').match(/(\d+(?:\.\d+)?)\s*%/u)?.[1]);
          return sum + (percentage === rate ? Math.max(0, Number(allocation.amount) || 0) : 0);
        }, 0);
        if (eligible > 0 && allocated + rounding < Math.round(eligible * rate / 100)) return false;
        original += eligible;
        saved += Math.min(eligible, allocated);
      } else {
        if (hasSelectedCode && before > 0) return false;
        const actual = Math.max(0, before - after);
        if (Math.abs(actual - Math.round(before * rate / 100)) > rounding) return false;
        original += before;
        saved += Math.min(before, actual);
      }
      tolerance += rounding;
    }
    const expected = Math.round(original * rate / 100);
    return original > 0 && saved > 0 && saved + tolerance >= expected;
  }
  function savings(cart = latestCart, profile = window.__initialData?.sale_profile || {}, requestedCount = count(cart)) {
    const result = { applied: false, maximum: false, discount: 0, best: 0 };
    if (!saleActive(profile) || profile.offer?.application_method === 'code') return result;
    const type = String(profile.type || '').toLowerCase();
    if (type === 'sitewide') {
      const offer = profile.offer || {};
      const rate = Number(profile.discount ?? offer.percentage_off ?? 0);
      if (offer.discount_type === 'fixed' || Number(offer.minimum_spend || 0) > 0 || rate <= 0 || rate > 100) return result;
      result.best = rate;
      result.discount = requestedCount > 0 ? rate : 0;
    } else if (type === 'tier' || type === 'panel_base_tier') {
      const source = type === 'panel_base_tier' ? profile.offer?.panel_discount_tiers : (Array.isArray(profile.offer?.tiers) ? profile.offer.tiers : profile.tiers);
      const baseCount = (cart?.items || []).reduce((sum, item) => sum + (isBase(item) ? units(item) : 0), 0);
      const tiers = (Array.isArray(source) ? source : []).filter(tier => !tier.synthetic).map(tier => ({
        count: Number(tier.panel_quantity ?? tier.req_art ?? tier.threshold ?? 0),
        discount: Number(tier.percentage_off ?? tier.discount ?? 0), bases: Number(tier.req_jackets || 0)
      })).filter(tier => Number.isInteger(tier.count) && tier.count > 0 && tier.discount > 0 && tier.discount <= 100);
      result.best = Math.max(0, ...tiers.map(tier => tier.discount));
      result.discount = tiers.reduce((best, tier) => requestedCount >= tier.count && baseCount >= tier.bases ? Math.max(best, tier.discount) : best, 0);
    }
    result.applied = savingsApplied(cart, result.discount, profile);
    result.maximum = result.best > 0 && result.discount >= result.best && result.applied;
    return result;
  }
  function firstSwapState(cart = latestCart) {
    const offer = window.__initialData?.firstSwapOffer || {};
    const code = String(offer.code || '').trim().toUpperCase();
    const handles = Array.isArray(offer.baseHandles) ? offer.baseHandles : [];
    const enabled = offer.enabled === true && /^[A-Z0-9_-]{3,64}$/.test(code) && handles.length > 0;
    const hasBase = enabled && (cart?.items || []).some(item => units(item) > 0 && handles.includes(item.handle));
    const eligible = hasBase && count(cart) > 0;
    const codeStatePresent = Object.prototype.hasOwnProperty.call(cart || {}, 'discount_codes');
    const selected = !codeStatePresent || Array.isArray(cart.discount_codes) && cart.discount_codes.some(entry =>
      String(entry?.code || '').trim().toUpperCase() === code && entry.applicable === true);
    const allocated = eligible && (cart?.items || []).filter(isPaidPanel).some(item =>
      [...(item.discount_allocations || []), ...(item.line_level_discount_allocations || [])].some(allocation => {
        const application = allocation?.discount_application || {};
        return String(application.code || application.title || '').trim().toUpperCase() === code && Number(allocation.amount) > 0;
      }));
    return { enabled, hasBase, eligible, applied: Boolean(eligible && selected && allocated) };
  }
  function promotionProgress(cart = latestCart, profile = window.__initialData?.sale_profile || {}) {
    const quantity = count(cart);
    const baseCount = (cart?.items || []).reduce((sum, item) => sum + (isBase(item) ? units(item) : 0), 0);
    const currentSavings = savings(cart, profile, quantity);
    const type = String(profile.type || '').toLowerCase();
    const source = type === 'panel_base_tier' ? profile.offer?.panel_discount_tiers :
      (Array.isArray(profile.offer?.tiers) ? profile.offer.tiers : profile.tiers);
    const tiers = saleActive(profile) && ['tier', 'panel_base_tier'].includes(type) && profile.offer?.application_method !== 'code'
      ? (Array.isArray(source) ? source : []).filter(tier => !tier.synthetic).map(tier => ({
        count: Number(tier.panel_quantity ?? tier.req_art ?? tier.threshold ?? 0),
        discount: Number(tier.percentage_off ?? tier.discount ?? 0), bases: Number(tier.req_jackets || 0)
      })).filter(tier => Number.isInteger(tier.count) && tier.count > 0 && tier.count <= MAX && tier.discount > currentSavings.discount && tier.discount <= 100)
        .sort((a, b) => a.count - b.count || a.discount - b.discount) : [];
    return { count: quantity, baseCount, savings: currentSavings, firstSwap: firstSwapState(cart), next: tiers[0] || null };
  }
  function milestoneText(key, fallback, values = {}) {
    let message = copy(key, fallback);
    for (const [name, value] of Object.entries(values)) message = message.replaceAll('__' + name.toUpperCase() + '__', String(value));
    return message;
  }
  function nextProgressMessage(current) {
    const next = current.next;
    if (!next) return '';
    if (current.baseCount < next.bases) return milestoneText('milestone_base_next', 'Add a base for __PERCENT__% off.', { percent: next.discount });
    const remaining = Math.max(0, next.count - current.count);
    if (!remaining) return '';
    return milestoneText(remaining === 1 ? 'milestone_next_one' : 'milestone_next_many',
      remaining === 1 ? '__COUNT__ more Swap for __PERCENT__% off.' : '__COUNT__ more Swaps for __PERCENT__% off.',
      { count: remaining, percent: next.discount });
  }
  function progressMessage(current, status = true) {
    const parts = [];
    if (status && current.savings.discount > 0) {
      const values = { percent: current.savings.discount };
      if (current.savings.maximum) parts.push(milestoneText('milestone_maximum_applied', '__PERCENT__% off applied. Max savings!', values));
      else if (current.savings.applied) parts.push(milestoneText('percentage_applied', '__PERCENT__% off applied', values));
      else parts.push(milestoneText('milestone_percent_unlocked', '__PERCENT__% off unlocked.', values));
    } else if (status && current.firstSwap.enabled) {
      if (current.firstSwap.applied) parts.push(copy('milestone_first_free', 'First Swap free!'));
      else if (current.count > 0 && !current.firstSwap.hasBase) parts.push(copy('milestone_add_base', 'Add a base to get your first Swap free.'));
      else parts.push(copy('first_swap_with_base', 'First Swap free with a base.'));
    }
    const next = nextProgressMessage(current);
    if (next && !(parts.length && current.baseCount < Number(current.next?.bases || 0))) parts.push(next);
    return parts.map((part, index) => index < parts.length - 1 && !/[.!?]$/u.test(part) ? part + '.' : part).join(' ');
  }
  function progressSignature(cart, profile) {
    const current = promotionProgress(cart, profile);
    return JSON.stringify([current.count, current.baseCount, current.savings, current.firstSwap, current.next,
      (cart?.discount_codes || []).map(entry => [String(entry?.code || '').trim().toUpperCase(), entry.applicable === true])]);
  }
  function feedback(previousState, state, cart = latestCart, profile = window.__initialData?.sale_profile || {}) {
    const before = Number(previousState?.panelCount);
    const after = Number(state?.panelCount);
    const panelsAdded = after > before;
    const basesAdded = Number(state?.baseCount || 0) > Number(previousState?.baseCount || 0);
    if (!previousState || !Number.isFinite(before) || (!panelsAdded && !basesAdded) || after !== count(cart)) return null;
    const current = promotionProgress(cart, profile);
    const previousSavings = previousState.savings || savings(cart, profile, before);
    const gainedSavings = current.savings.discount > Number(previousSavings.discount || 0);
    const gainedFreeSwap = current.firstSwap.applied && previousState.firstSwap?.applied !== true;
    const firstPanel = panelsAdded && before === 0 && current.firstSwap.enabled;
    const earned = gainedSavings || gainedFreeSwap || firstPanel;
    const message = earned ? progressMessage(current) : panelsAdded ? progressMessage(current, false) : '';
    if (!message) return null;
    return {
      type: 'bundle-tier', previousState, message,
      icon: gainedSavings || gainedFreeSwap ? 'celebrate' : 'check',
      className: 'custom-toast-sms--dark', timeout: earned ? 3800 : 3000
    };
  }
  function root() { return (document.documentElement?._x_dataStack || []).find(scope => scope && typeof scope.runCartMutation === 'function'); }
  async function sync(scope, request) {
    const result = await scope.reconcileCart(request);
    if (result?.cart) observe(result.cart);
    return result;
  }
  async function run(task) {
    const scope = root();
    if (!scope) return { ok: false, error: new Error(copy('refresh_error', 'Refresh this page and try again.')) };
    return scope.runCartMutation(request => task(scope, request), { resumeAfterRefresh: true });
  }
  async function reduce(value, keepKeys) {
    const target = Number(value);
    if (!Number.isInteger(target) || target < 1 || target > MAX || !Array.isArray(keepKeys)) return { ok: false, error: new Error(copy('choose_keep', 'Choose which panels to keep.')) };
    return run(async (scope, request) => {
      try {
        const before = await scope.updateCart(false, { request });
        if (before?.ok !== true || !Array.isArray(before.cart?.items)) throw new Error(copy('refresh_error', 'Your cart could not be confirmed. Refresh your cart and try again.'));
        const cart = before.cart;
        const filled = slots(cart).filter(Boolean);
        const selected = new Set(keepKeys.map(String));
        if (selected.size !== target || [...selected].some(key => !filled.some(slot => slot.slotKey === key))) throw new Error(copy('choose_keep', 'Choose which panels to keep.'));
        const updates = {};
        filled.forEach(slot => { updates[slot.key] ||= 0; if (selected.has(slot.slotKey)) updates[slot.key] += 1; });
        const response = await request(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        if (!response.ok) throw new Error(copy('reduce_error', 'Your bundle could not be updated. Please try again.'));
        const reconciliation = await sync(scope, request);
        if (count(latestCart) !== target) throw new Error(copy('changed_error', 'Your bundle has changed. Review it and try again.'));
        activateGoal(target, latestCart);
        if (reconciliation?.ok !== true) return { ok: false, mutationConfirmed: true, error: reconciliation?.error || new Error(copy('refresh_error', 'Your cart could not be confirmed. Refresh your cart and try again.')) };
        return { ok: true, mutationConfirmed: true };
      } catch (error) {
        try { await scope.updateCart(false, { request }); } catch (_) {}
        return { ok: false, error };
      }
    });
  }
  window.swapwearPanelSet = { max: MAX, goal: () => selectedGoal, count, slots, snapshot, selectGoal, activateGoal, activatePromotion, consumeActivation, savingsApplied, savings, firstSwapState, feedback, requestGoal: selectGoal, observe, reduce, requestReview: cart => emit('build:set-preview-open', snapshot(cart)) };
  persist();
  observe(latestCart, false);
  // Only a recent explicit cross-page selection can produce a load-time toast.
  document.addEventListener?.('alpine:initialized', consumeActivation);
  window.addEventListener('load', consumeActivation);
  window.addEventListener('swapwear:cart-mutation-confirmed', () => staleGrowthCarts.clear());
  window.addEventListener('cart:updated', event => observe(event.detail?.cart));
  window.addEventListener('swapwear:cart-restored', event => observe(event.detail?.cart));
  window.addEventListener('storage', event => {
    if (event.key !== STORAGE) return;
    const value = Number(event.newValue);
    if (!Number.isSafeInteger(value) || value < 1) return;
    selectedGoal = Math.min(MAX, value);
    protectGoalFromOldCarts(selectedGoal);
    persist();
    changed(latestCart, 'storage');
    try { Promise.resolve(root()?.updateCart?.(false, { passive: true })).catch(() => {}); } catch (_) {}
  });
}());
